@if (isOpen) {
<div class="search-overlay" (click)="closeSearch()">
  <div class="search-panel" (click)="$event.stopPropagation()">
    <div class="search-panel__head">
      <h2 class="search-title">Search The Site</h2>
      <button class="search-close" type="button" (click)="closeSearch()" aria-label="Close search">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
          <path d="M6.7 5.3 12 10.6l5.3-5.3 1.4 1.4L13.4 12l5.3 5.3-1.4 1.4L12 13.4l-5.3 5.3-1.4-1.4 5.3-5.3-5.3-5.3z" />
        </svg>
      </button>
    </div>

    <div class="search-input-wrapper">
      <svg class="search-input-icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path
          d="M11 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm9.7 14.3a1 1 0 0 1 0 1.4 1 1 0 0 1-1.4 0l-3.2-3.2a1 1 0 1 1 1.4-1.4l3.2 3.2z" />
      </svg>
      <input
        class="search-input"
        type="text"
        [value]="searchQuery"
        (input)="onSearchQueryChange($any($event.target).value)"
        placeholder="What are you looking for?"
        autofocus
      />
    </div>

    @if (groupedSearchResults.length > 0) {
    <div class="search-results">
      @for (group of groupedSearchResults; track group.key) {
      <div class="search-group">
        <h3 class="search-group__title">{{ group.label }}</h3>
        <div class="search-group__items">
          @for (item of group.items; track item.id) {
          <button class="search-result" [class.search-result--no-media]="!hasRenderableImage(item)" type="button" (click)="navigateFromSearch(item)">
            @if (hasRenderableImage(item)) {
            <div class="search-result__media">
              <img class="search-result__image" [src]="item.imageUrl" [alt]="item.title" loading="lazy" decoding="async" (error)="onImageError(item.id)" />
            </div>
            }

            <div class="search-result__content">
              <span class="search-result__type">{{ getSearchTypeLabel(item.type) }}</span>
              <span class="search-result__title">{{ item.title }}</span>
              <span class="search-result__subtitle">{{ item.subtitle }}</span>
            </div>
          </button>
          }
        </div>
      </div>
      }
    </div>
    }

    @if (groupedSearchResults.length === 0) {
    <p class="search-empty">No results found for "{{ searchQuery }}".</p>
    }
  </div>
</div>
}
